<body class="exception-body notfound">
  <div class="exception-panel">
    <div class="exception-panel-content">
      <img src="../layout/images/exception/404-icon.png">
      <h1>404</h1>
      <p>The requested page cannot be found.</p>
    </div>

    <div class="exception-panel-footer">
      <a href="#/main">Click to go back to the main pag
        <i class="fa fa-home fa-2x fa-pull-rightright fa-border"></i>
      </a>
    </div>
  </div>
</body>